import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
const defaultKey = ['objective'];
const keys = {
    default: defaultKey,
    objective: (id) => {
        return compact([...defaultKey, id]);
    },
    objectiveWithParams: (id, params) => {
        return compact([...defaultKey, id, isEmpty(params) ? undefined : params]);
    },
    // Lean v4 detail base (#8567). Own segment so the v4-lean detail body can't
    // share a cache entry with the v3-full body the edit form still fetches under
    // objectiveWithParams; the ['objective', id] prefix still invalidates it.
    objectiveDetailV4: (id, params) => {
        return compact([...defaultKey, id, 'v4-detail', params]);
    },
    permissions: (id, params) => {
        return compact([...defaultKey, id, 'permissions', params]);
    },
    // Rich parents sub-resource (#8567). Own segment, cutoff-param-keyed like the
    // detail base; the ['objective', id] prefix still invalidates it on refetch.
    parents: (id, params) => {
        return compact([...defaultKey, id, 'parents', params]);
    },
    // Review sub-resource (#8567), same keying as parents above.
    rating: (id, params) => {
        return compact([...defaultKey, id, 'rating', params]);
    },
    childrenCount: (id, params) => {
        return compact([...defaultKey, 'children_count', id, params]);
    },
    involvements: (id, params) => {
        return compact([...defaultKey, id, 'involvements', params]);
    },
    sharedInvolvements: (id) => {
        return compact([...defaultKey, id, 'shared-involvements']);
    },
    milestone: (id, milestoneSeries) => {
        return compact([...defaultKey, id, 'milestone-list', milestoneSeries]);
    },
    attachment: (id) => {
        return compact([...defaultKey, id, 'attachments']);
    },
    topChildrenWarning: (id) => {
        return compact([...defaultKey, id, 'top-children-warning']);
    },
    topParentWarning: (id) => {
        return compact([...defaultKey, id, 'top-parent-warning']);
    },
    sharedInvolvementsWarning: (params) => {
        return compact([...defaultKey, 'shared-involvements-warning', params]);
    },
    lastComment: (id) => {
        return compact([...defaultKey, id, 'last-comment']);
    },
    progressHistory: (params) => {
        return compact([...defaultKey, 'progress-history', params]);
    },
    customFields: (id) => {
        return compact([...defaultKey, 'custom-fields', id]);
    },
    calculationTypeOptions: [...defaultKey, 'calculation-type-options']
};
export default keys;
